const transformAndroidId = (url) => {
    if (!url?.match(/^https?:\/\//))
        return url;
    if (!url)
        return;
    try {
        const urlObject = new URL(url);
        const id = urlObject.searchParams.get('id');
        if (id) {
            return id;
        }
    }
    catch {
        // ignore
    }
    return;
};

export { transformAndroidId };
